import $ from 'jquery'
import 'slick-carousel'
import { readViewedHomeIds } from 'javascripts/shared/viewed_homes'

// perView: slides shown above 1600px; one fewer at 1600px and below (slick applies a breakpoint below the given
// width, so 1601 makes 1600 itself use the smaller count).
function initHomeCardsCarousel($list, perView = 5) {
  $list.slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: perView,
    slidesToScroll: perView,
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: perView - 1,
          slidesToScroll: perView - 1,
        },
      },
      {
        breakpoint: 768,
        settings: 'unslick',
      },
    ],
  })
}

// 閲覧履歴: localStorage の家 id から、検索ボックス下に出ている家を除いた最大12件をサーバーに描画してもらう
function loadRecentlyViewedHomes() {
  const section = document.getElementById('top-recently-viewed-section')
  if (!section) return

  const exclude = new Set((section.dataset.excludeIds || '').split(',').filter(Boolean))
  const ids = readViewedHomeIds()
    .filter((id) => !exclude.has(id))
    .slice(0, Number(section.dataset.limit))
  if (ids.length === 0) return

  fetch(`${section.dataset.url}?ids=${encodeURIComponent(ids.join(','))}`, {
    headers: { Accept: 'text/html' },
    credentials: 'same-origin',
  })
    .then((response) => (response.ok && response.status !== 204 ? response.text() : ''))
    .then((html) => {
      if (!html.trim()) return
      const list = document.getElementById('top-recently-viewed-homes')
      list.innerHTML = html
      section.classList.remove('hidden')
      initHomeCardsCarousel($(list))
    })
    .catch(() => {})
}

$(function () {
  $('.top-kv-slider')
    .on('init', function () {
      $('.slick-slide[data-slick-index="0"]').addClass('add-animation')
    })
    .slick({
      autoplay: true,
      fade: true,
      arrows: false,
      speed: 3000,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false,
    })
    .on({
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        $('.slick-slide', this).eq(nextSlide).addClass('add-animation')
        $('.slick-slide', this).eq(currentSlide).addClass('remove-animation')
      },
      afterChange: function () {
        $('.remove-animation', this).removeClass('remove-animation add-animation')
      },
    })

  //よくある質問などのアコーディオンUI
  $('.accordion dd').hide()
  $('.accordion dt').on('click', function () {
    $('+dd', this).slideToggle(300)
  })

  //ページ内アンカーリンクスクロール
  $('a[href*="#"]').on('click', function () {
    var elmHash = $(this).attr('href')
    var pos = $(elmHash).offset().top - 100
    $('body,html').animate({ scrollTop: pos }, 500)
    return false
  })

  // カードの横並び（検索ボックス下・タグ別・テーマリスト・イベント・コラム・家守ニュース）: PC は矢印送り、SP はスライダーにせず横スクロール。
  // 1画面の件数は data-per-view（既定 5、1600px以下は 1 件少ない。SCSS の --per-view と揃える）
  // 閲覧履歴の行は空のまま出力され後から中身が入るので、ここでは初期化しない（loadRecentlyViewedHomes が行う）
  // 閲覧履歴の行だけは除く。:empty はテキストノード1つで外れるので、行の id で名指しする
  $('.top-homes-row')
    .not('#top-recently-viewed-homes')
    .each((_, row) => initHomeCardsCarousel($(row), Number(row.dataset.perView) || 5))

  loadRecentlyViewedHomes()
  // 家画像modal
  ;(function () {
    const openbtns = document.querySelectorAll('.modal-open')
    const closebtns = document.querySelectorAll('.modal-close')
    const wrapper = document.querySelector('.modal-wrapper')
    const modalOpen = (btn) => {
      const modalId = btn.dataset.modal
      const modal = document.querySelector(`.modal[data-modal="${modalId}"]`)
      modal.insertAdjacentHTML('beforeend', '<i class="modal-bg"></i>')
      modal.classList.add('is-open')
      const top = window.scrollY
      wrapper.classList.add('is-modalopen')
      wrapper.style.top = `-${top}px`
      const modalbg = document.querySelector('.modal-bg')
      modalbg.addEventListener('click', () => {
        modalClose()
      })
    }
    const modalClose = () => {
      const modal = document.querySelector(`.modal.is-open`)
      const getY = (callback) => {
        modal.classList.remove('is-open')
        const modalbg = document.querySelector('.modal-bg')
        const top = wrapper.style.top
        const y = top.slice(1, -2)
        wrapper.style.top = ''
        wrapper.classList.remove('is-modalopen')
        modalbg.parentNode.removeChild(modalbg)
        callback(y)
      }
      getY((y) => {
        window.scrollTo(0, y)
      })
    }
    openbtns.forEach((openbtn) => {
      openbtn.addEventListener('click', (event) => {
        const btn = event.currentTarget
        modalOpen(btn)
      })
    })
    closebtns.forEach((closebtn) => {
      closebtn.addEventListener('click', () => {
        modalClose()
      })
    })
  })()
})
